// @file Helper for section.
export type Section = {
  id: number
}

export function isNew(section: Section): boolean {
  return String(section.id).startsWith('new_')
}
